import * as React from "react";
const SvgTonicIcon = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none" }, props),
    React.createElement("path", { fill: "#00DCDC", d: "M16 0h-3.242L0 12.76V16h3.235L16 3.24V0Z" }),
    React.createElement("path", { fill: "url(#TonicIcon_svg__a)", d: "M11.417 15.992H16V3.241l-4.583 4.58v8.171Z" }),
    React.createElement("path", { fill: "url(#TonicIcon_svg__b)", d: "M4.576 0H0v12.76l4.576-4.582V0Z" }),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "TonicIcon_svg__a", x1: 11.662, x2: 16.076, y1: 7.575, y2: 11.991, gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#008F8F" }),
            React.createElement("stop", { offset: 1, stopColor: "#00DCDC" })),
        React.createElement("linearGradient", { id: "TonicIcon_svg__b", x1: 4.333, x2: -0.08, y1: 8.424, y2: 4.008, gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#008F8F" }),
            React.createElement("stop", { offset: 1, stopColor: "#00DCDC" })))));
export default SvgTonicIcon;
